export const WidgetZIndexChange = ({
    action, // "BringFront" | "SendBack"
    setIsSubMenu,
    currentDevice,
    activeTabIndex,
    selectedDevice,
    clickedDeviceIndex,
    tempImages,
    setTempImages,
    setUpdatedImages,

    // ===== TEMP TAB INDEX =====
    tempTabIndexSquare,
    tempTabIndexCircle,
    tempTabIndexImages,
    tempTabIndexDisplay,
    tempTabIndexDevices,
    tempTabIndexController,
    tempTabIndexFlowM,
    tempTabIndexEnergyM,
    tempTabIndexMotor,
    tempTabIndexText,
    tempTabIndexLineChart,
    tempTabIndexPieChart,
    tempTabIndexBarChart,
    tempTabIndexHistogram,
    tempTabIndexGauge,
    tempTabIndexProgress,
    tempTabIndexCircularProgress,
    tempTabIndexDoughnut,
    tempTabIndexGrid,
    tempTabIndexTable,
    tempTabIndexLines,
    tempTabIndexPolygone,
    tempTabIndexPipe,
    tempTabIndexSwitch,
    tempTabIndexCheckbox,
    tempTabIndexRadio,
    tempTabIndexSlider,
    tempTabIndexLamp,
    tempTabIndexPush,
    tempTabIndexLink,
    tempTabIndexClock,

    // ===== SET TEMP TAB INDEX =====
    setTempTabIndexSquare,
    setTempTabIndexCircle,
    setTempTabIndexImages,
    setTempTabIndexDisplay,
    setTempTabIndexDevices,
    setTempTabIndexController,
    setTempTabIndexFlowM,
    setTempTabIndexEnergyM,
    setTempTabIndexMotor,
    setTempTabIndexText,
    setTempTabIndexLineChart,
    setTempTabIndexPieChart,
    setTempTabIndexBarChart,
    setTempTabIndexHistogram,
    setTempTabIndexGauge,
    setTempTabIndexProgress,
    setTempTabIndexCircularProgress,
    setTempTabIndexDoughnut,
    setTempTabIndexGrid,
    setTempTabIndexTable,
    setTempTabIndexLines,
    setTempTabIndexPolygone,
    setTempTabIndexPipe,
    setTempTabIndexSwitch,
    setTempTabIndexCheckbox,
    setTempTabIndexRadio,
    setTempTabIndexSlider,
    setTempTabIndexLamp,
    setTempTabIndexPush,
    setTempTabIndexLink,
    setTempTabIndexClock,

    // ===== MULTIPLE =====
    multipleSquare, setMultipleSquare,
    multipleCircle, setMultipleCircle,
    multipleImages, setMultipleImages,
    multipleDisplay, setMultipleDisplay,
    multipleDevices, setMultipleDevices,
    multipleController, setMultipleController,
    multipleFlowM, setMultipleFlowM,
    multipleEnergyM, setMultipleEnergyM,
    multipleMotor, setMultipleMotor,
    multipleText, setMultipleText,
    multipleLineCharts, setMultipleLineCharts,
    multiplePieChart, setMultiplePieChart,
    multipleBarChart, setMultipleBarChart,
    multipleHistogram, setMultipleHistogram,
    multipleGauge, setMultipleGauge,
    multipleProgress, setMultipleProgress,
    multipleCircularProgress, setMultipleCircularProgress,
    multipleDoughnut, setMultipleDoughnut,
    multipleGrid, setMultipleGrid,
    multipleTable, setMultipleTable,
    multipleLines, setMultipleLines,
    multiplePolygone, setMultiplePolygone,
    multiplePipe, setMultiplePipe,
    multipleSwitch, setMultipleSwitch,
    multipleCheckbox, setMultipleCheckbox,
    multipleRadio, setMultipleRadio,
    multipleSlider, setMultipleSlider,
    multipleLamp, setMultipleLamp,
    multiplePush, setMultiplePush,
    multipleLink, setMultipleLink,
    multipleClock, setMultipleClock,
}) => {

    setIsSubMenu(false);

    /** 🔹 Helpers */
    const getMaxZIndex = (devices = []) =>
        devices.reduce((max, d) => Math.max(max, d?.zIndex ?? 1), 1);

    const getMinZIndex = (devices = []) =>
        devices.reduce((min, d) => Math.min(min, d?.zIndex ?? 1), Infinity);

    /** 🔹 Core logic */
    const updateZIndex = (tempTabIndex, setTempTabIndex, multipleDevices, setMultipleDevices) => {
        const devicesInTab = tempTabIndex[activeTabIndex];
        if (!devicesInTab) return;

        /** ===== SINGLE SELECTION ===== */
        if (selectedDevice?.id) {
            const target = devicesInTab[clickedDeviceIndex];
            if (!target || target.id !== selectedDevice.id) return;

            let newZ;
            if (action === "BringFront") {
                newZ = getMaxZIndex(devicesInTab) + 1;
            } else {
                const minZ = getMinZIndex(devicesInTab);
                newZ = Math.max(1, minZ - 1);
            }

            devicesInTab[clickedDeviceIndex] = {
                ...target,
                zIndex: newZ,
            };

            setTempTabIndex({
                ...tempTabIndex,
                [activeTabIndex]: [...devicesInTab],
            });

            const imgIndex = tempImages.findIndex(d => d.id === selectedDevice.id);
            if (imgIndex !== -1) {
                const updated = [...tempImages];
                updated[imgIndex] = { ...updated[imgIndex], zIndex: newZ };
                setTempImages(updated);
                setUpdatedImages(updated);
            }
        }

        /** ===== MULTIPLE SELECTION ===== */
        if (!selectedDevice?.id && multipleDevices?.length > 1) {
            let newZ;
            if (action === "BringFront") {
                newZ = getMaxZIndex(multipleDevices) + 1;
            } else {
                const minZ = getMinZIndex(multipleDevices);
                newZ = Math.max(1, minZ - 1);
            }

            const updated = [...multipleDevices];
            updated[clickedDeviceIndex] = {
                ...updated[clickedDeviceIndex],
                zIndex: newZ,
            };

            setMultipleDevices(updated);
        }
    };

    /** 🔹 Device mapping */
    const deviceMappings = {
        Image: { tempTabIndex: tempTabIndexImages, setTempTabIndex: setTempTabIndexImages, multiple: multipleImages, setMultiple: setMultipleImages },
        Display: { tempTabIndex: tempTabIndexDisplay, setTempTabIndex: setTempTabIndexDisplay, multiple: multipleDisplay, setMultiple: setMultipleDisplay },
        Indicator: { tempTabIndex: tempTabIndexDevices, setTempTabIndex: setTempTabIndexDevices, multiple: multipleDevices, setMultiple: setMultipleDevices },
        Controller: { tempTabIndex: tempTabIndexController, setTempTabIndex: setTempTabIndexController, multiple: multipleController, setMultiple: setMultipleController },
        FlowMeter: { tempTabIndex: tempTabIndexFlowM, setTempTabIndex: setTempTabIndexFlowM, multiple: multipleFlowM, setMultiple: setMultipleFlowM },
        EnergyMeter: { tempTabIndex: tempTabIndexEnergyM, setTempTabIndex: setTempTabIndexEnergyM, multiple: multipleEnergyM, setMultiple: setMultipleEnergyM },
        Motor: { tempTabIndex: tempTabIndexMotor, setTempTabIndex: setTempTabIndexMotor, multiple: multipleMotor, setMultiple: setMultipleMotor },
        Text: { tempTabIndex: tempTabIndexText, setTempTabIndex: setTempTabIndexText, multiple: multipleText, setMultiple: setMultipleText },
        LineChart: { tempTabIndex: tempTabIndexLineChart, setTempTabIndex: setTempTabIndexLineChart, multiple: multipleLineCharts, setMultiple: setMultipleLineCharts },
        PieChart: { tempTabIndex: tempTabIndexPieChart, setTempTabIndex: setTempTabIndexPieChart, multiple: multiplePieChart, setMultiple: setMultiplePieChart },
        BarChart: { tempTabIndex: tempTabIndexBarChart, setTempTabIndex: setTempTabIndexBarChart, multiple: multipleBarChart, setMultiple: setMultipleBarChart },
        Histogram: { tempTabIndex: tempTabIndexHistogram, setTempTabIndex: setTempTabIndexHistogram, multiple: multipleHistogram, setMultiple: setMultipleHistogram },
        Gauge: { tempTabIndex: tempTabIndexGauge, setTempTabIndex: setTempTabIndexGauge, multiple: multipleGauge, setMultiple: setMultipleGauge },
        ProgressBar: { tempTabIndex: tempTabIndexProgress, setTempTabIndex: setTempTabIndexProgress, multiple: multipleProgress, setMultiple: setMultipleProgress },
        CircularProgress: { tempTabIndex: tempTabIndexCircularProgress, setTempTabIndex: setTempTabIndexCircularProgress, multiple: multipleCircularProgress, setMultiple: setMultipleCircularProgress },
        Doughnut: { tempTabIndex: tempTabIndexDoughnut, setTempTabIndex: setTempTabIndexDoughnut, multiple: multipleDoughnut, setMultiple: setMultipleDoughnut },
        Grid: { tempTabIndex: tempTabIndexGrid, setTempTabIndex: setTempTabIndexGrid, multiple: multipleGrid, setMultiple: setMultipleGrid },
        Table: { tempTabIndex: tempTabIndexTable, setTempTabIndex: setTempTabIndexTable, multiple: multipleTable, setMultiple: setMultipleTable },
        Line: { tempTabIndex: tempTabIndexLines, setTempTabIndex: setTempTabIndexLines, multiple: multipleLines, setMultiple: setMultipleLines },
        Square: { tempTabIndex: tempTabIndexSquare, setTempTabIndex: setTempTabIndexSquare, multiple: multipleSquare, setMultiple: setMultipleSquare },
        Circle: { tempTabIndex: tempTabIndexCircle, setTempTabIndex: setTempTabIndexCircle, multiple: multipleCircle, setMultiple: setMultipleCircle },
        Polygone: { tempTabIndex: tempTabIndexPolygone, setTempTabIndex: setTempTabIndexPolygone, multiple: multiplePolygone, setMultiple: setMultiplePolygone },
        Pipe: { tempTabIndex: tempTabIndexPipe, setTempTabIndex: setTempTabIndexPipe, multiple: multiplePipe, setMultiple: setMultiplePipe },
        Switch: { tempTabIndex: tempTabIndexSwitch, setTempTabIndex: setTempTabIndexSwitch, multiple: multipleSwitch, setMultiple: setMultipleSwitch },
        Checkbox: { tempTabIndex: tempTabIndexCheckbox, setTempTabIndex: setTempTabIndexCheckbox, multiple: multipleCheckbox, setMultiple: setMultipleCheckbox },
        Radio: { tempTabIndex: tempTabIndexRadio, setTempTabIndex: setTempTabIndexRadio, multiple: multipleRadio, setMultiple: setMultipleRadio },
        Slider: { tempTabIndex: tempTabIndexSlider, setTempTabIndex: setTempTabIndexSlider, multiple: multipleSlider, setMultiple: setMultipleSlider },
        Lamp: { tempTabIndex: tempTabIndexLamp, setTempTabIndex: setTempTabIndexLamp, multiple: multipleLamp, setMultiple: setMultipleLamp },
        Push: { tempTabIndex: tempTabIndexPush, setTempTabIndex: setTempTabIndexPush, multiple: multiplePush, setMultiple: setMultiplePush },
        Link: { tempTabIndex: tempTabIndexLink, setTempTabIndex: setTempTabIndexLink, multiple: multipleLink, setMultiple: setMultipleLink },
        Clock: { tempTabIndex: tempTabIndexClock, setTempTabIndex: setTempTabIndexClock, multiple: multipleClock, setMultiple: setMultipleClock },
    };

    if (deviceMappings[currentDevice]) {
        const d = deviceMappings[currentDevice];
        updateZIndex(d.tempTabIndex, d.setTempTabIndex, d.multiple, d.setMultiple);
    }
};
